function filterCatalog(models, family = 'all', sort = 'featured') {
  const result = models.filter(model => family === 'all' || model.family === family);
  if (sort === 'price-ascending') result.sort((a, b) => a.price - b.price);
  if (sort === 'price-descending') result.sort((a, b) => b.price - a.price);
  return result;
}

function variantPricing(priceCents, compareAtPriceCents) {
  const price = Number(priceCents);
  const compareAtPrice = Number(compareAtPriceCents);
  const onSale = Number.isFinite(price) && Number.isFinite(compareAtPrice) && compareAtPrice > price;
  const discountPercent = onSale ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100) : 0;

  return {
    onSale,
    discountPercent,
    discountLabel: onSale ? `${discountPercent}% OFF` : '',
  };
}

const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
const dialogs = new Map();

function mountGallery(root) {
  root.querySelectorAll('[data-gallery]:not([data-bound])').forEach(gallery => {
    gallery.dataset.bound = 'true';
    const rail = gallery.querySelector('[data-gallery-rail]');
    const slides = Array.from(rail.children);
    const count = gallery.querySelector('[data-gallery-count]');
    const controls = gallery.querySelectorAll('[data-gallery-step]');
    const thumbs = gallery.querySelectorAll('[data-gallery-index]');
    gallery.querySelector('.ap-gallery__controls').hidden = false;
    const thumbRail = gallery.querySelector('.ap-gallery__thumbs');
    if (thumbRail) thumbRail.hidden = false;
    const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(rail.scrollLeft / (rail.clientWidth || 1))));
    const update = () => {
      const current = index();
      count.textContent = `${current + 1} / ${slides.length}`;
      controls.forEach(button => { button.disabled = Number(button.dataset.galleryStep) < 0 ? current === 0 : current === slides.length - 1; });
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
    };
    const move = step => rail.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, index() + step)) * rail.clientWidth, behavior: motion() });
    controls.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.galleryStep))));
    thumbs.forEach(button => button.addEventListener('click', () => rail.scrollTo({ left: Number(button.dataset.galleryIndex) * rail.clientWidth, behavior: motion() })));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    update();
  });
}

function mount() {
  document.querySelectorAll('[data-catalog]:not([data-bound])').forEach(catalog => {
    catalog.dataset.bound = 'true';
    const grid = catalog.querySelector('[data-catalog-grid]');
    const models = Array.from(grid.querySelectorAll('[data-catalog-card]')).map(element => ({ element, ...element.dataset, price: Number(element.dataset.price) }));
    let family = 'all';
    const select = catalog.querySelector('[data-sort]');
    const filters = catalog.querySelectorAll('[data-filter]');
    const update = () => {
      const chosen = filterCatalog(models, family, select.value);
      models.forEach(model => { model.element.hidden = !chosen.includes(model); });
      chosen.forEach(model => grid.append(model.element));
      catalog.querySelector('[data-catalog-count]').textContent = `${chosen.length} MODELS`;
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === family)));
    };
    filters.forEach(button => button.addEventListener('click', () => { family = button.dataset.filter; update(); }));
    select.addEventListener('change', update);
    catalog.querySelector('[data-catalog-toolbar]').hidden = false;
    update();
  });

  if ('HTMLDialogElement' in window) document.querySelectorAll('[data-preview]:not([data-enhanced])').forEach(preview => {
    const dialog = document.createElement('dialog');
    dialog.className = 'ap-modal';
    dialog.setAttribute('aria-label', preview.querySelector('h2').textContent + ' 商品プレビュー');
    const bar = document.createElement('div'); bar.className = 'ap-modal__bar';
    const label = document.createElement('span'); label.textContent = 'APERTEO / MODEL PREVIEW';
    const close = document.createElement('button'); close.type = 'button'; close.className = 'ap-modal__close'; close.textContent = '×'; close.setAttribute('aria-label', '商品プレビューを閉じる');
    bar.append(label, close); dialog.append(bar, preview.querySelector('.ap-preview__body'));
    preview.after(dialog); preview.dataset.enhanced = 'true';
    dialogs.set(preview.id, dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => {
      document.body.classList.toggle('ap-modal-open', Array.from(dialogs.values()).some(item => item.open));
      if (location.hash === '#' + preview.id) history.replaceState(null, '', location.pathname + location.search);
      dialog.returnFocus?.focus({ preventScroll: true });
    });
  });
  mountGallery(document);

  document.querySelectorAll('[data-ap-variant-select]:not([data-ap-bound])').forEach(select => {
    select.dataset.apBound = 'true';
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const product = select.closest('.ap-product');
      const available = option?.dataset.available === 'true';
      const pricing = variantPricing(option?.dataset.priceCents, option?.dataset.comparePriceCents);
      product.querySelectorAll('[data-ap-price]').forEach(price => { price.textContent = option.dataset.price; });
      product.querySelectorAll('[data-ap-compare-price]').forEach(comparePrice => {
        comparePrice.textContent = option.dataset.comparePrice;
        comparePrice.hidden = !pricing.onSale;
      });
      product.querySelectorAll('[data-ap-discount]').forEach(discount => {
        discount.textContent = pricing.discountLabel;
        discount.hidden = !pricing.onSale;
      });
      product.querySelector('[data-ap-submit]').disabled = !available;
      product.querySelector('[data-ap-submit-label]').textContent = available ? 'カートに追加' : '売り切れ';
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState(null, '', url);
      const media = Array.from(product.querySelectorAll('[data-media-id]')).find(node => node.dataset.mediaId === option.dataset.mediaId);
      if (media) { const rail = product.querySelector('[data-gallery-rail]'); rail.scrollTo({ left: media.offsetLeft - rail.firstElementChild.offsetLeft, behavior: motion() }); }
    });
  });
}

function openModel(id, trigger) {
  const dialog = dialogs.get(id);
  if (!dialog || !dialog.isConnected) return false;
  dialogs.forEach(other => { if (other !== dialog && other.open) other.close(); });
  if (!dialog.open) { dialog.returnFocus = trigger || null; dialog.showModal(); dialog.scrollTop = 0; }
  document.body.classList.add('ap-modal-open');
  return true;
}

document.addEventListener('click', event => {
  const anchor = event.target.closest('a[href]');
  if (!anchor || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const url = new URL(anchor.href);
  if (url.origin === location.origin && url.pathname === location.pathname && url.hash.startsWith('#model-') && openModel(url.hash.slice(1), anchor)) {
    event.preventDefault(); history.pushState(null, '', url.hash);
  }
  anchor.closest('.ap-mobile-menu')?.removeAttribute('open');
});
document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelector('.ap-mobile-menu[open]')?.removeAttribute('open'); });
window.addEventListener('hashchange', () => { if (!openModel(location.hash.slice(1))) dialogs.forEach(dialog => { if (dialog.open) dialog.close(); }); });
document.addEventListener('shopify:section:load', mount);
mount();
openModel(location.hash.slice(1));
